export { default as isNotNullOrEmpty } from "./isNotNullOrEmpty"
export { default as isset } from "./isset"
import { isString, isObject } from "./isType"
export * from "./isset"
export * from "./isType"

export const isEmptyString = (value) => isString(value) && value.trim().length === 0
export const isNotEmptyString = (value) => isString(value) && value.trim().length !== 0
export const isEmptyObject = (value) => isObject(value) && Object.keys(value).length === 0

export const isJpeg = (ext) => ext === "jpg" || ext === "jpeg"
export const isPng = (ext) => ext === "png"
export const isPdf = (ext) => ext === "pdf"
